export default __webpack_public_path__ + "d1f9e63177c9b1e8dcb585a57730c123.svg";